import './selectStakeholder.css';
import React, { useState, useEffect, useRef } from "react";
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import Table from 'react-bootstrap/Table';
import { viewMappedDetails } from './stakeholderMappingApi';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { NO_DATA_AVAILABLE, PROD } from '../../../common/constants';
import { DataGrid } from '@mui/x-data-grid';
import { Container, Stack, Box, Typography, Grid, Card, CardContent, Button, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const ViewOtherMappedStakeholder = (props) => {
    const viewlog = useRef(true);
    const [viewMappedStakeHolder, setViewMappedStakeHolder] = useState([]);
    useEffect(() => {
        if (viewlog.current) {
            viewlog.current = false;
            viewMappedDetails(props.linkedto, props.growerLandId, props.urn, setViewMappedStakeHolder)
        }
    }, [viewlog, props.linkedto, props.growerLandId, props.urn, setViewMappedStakeHolder]);
    const viewcol = [
        { field: 'targetStakeholderName', headerName: 'Targeted StakeholderName', width: 250 },
        { field: 'targetStakeholderUrn', headerName: 'Targeted StakeholderURN', width: 240 },
        { field: 'targetStakeholderType', headerName: 'Targeted StakeholderType', width: 220 }
    ]
    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p className='pageNumberingResc'>RES02</p>}
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h5" gutterBottom>
                        Select Stakeholder Mapping
                    </Typography>
                    <CloseIcon alignItem="flex-end" onClick={props.handleMappedModalClose}/>
                </Stack>
                <Card>
                    <CardContent>
                        {(viewMappedStakeHolder.length > 0) ?
                            <Grid container spacing={1} sx={{ mt: 3 }}>
                                <Grid item xs={12} lg={12}>
                                    <Box sx={{ height: 230, width: '100%' }}>
                                        <DataGrid
                                            rows={viewMappedStakeHolder}
                                            columns={viewcol}
                                            pageSize={5}
                                            rowsPerPageOptions={[5]}
                                            getRowId={(row) => row?.targetStakeholderUrn}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                            :
                            <Typography display='flex' alignItems="center" justifyContent="center" sx={{ fontWeight: "bold" }}>{NO_DATA_AVAILABLE}</Typography>
                        }
                        {/* <Box display='flex' justifyContent="flex-end">
                            <Button sx={{ minWidth: 100, mt: 1 }} variant="contained" onClick={props.handleMappedModalClose}>OK</Button>
                        </Box> */}
                    </CardContent>
                </Card>
            </Container>
        </>

    );
};
